import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { Shell } from '@app/shell/services/shell.service';
import { PermissionGuard } from '@app/auth/guard/permission.guard';

const routes = [
  Shell.childRoutes([
    {
      path: '',
      canActivateChild: [PermissionGuard],
      loadChildren: () => import('./web/web.module').then((m) => m.WebModule),
    },
    {
      path: 'm',
      canActivateChild: [PermissionGuard],
      loadChildren: () => import('./mobile/mobile.module').then((m) => m.MobileModule),
    },
    // Fallback when no prior route is matched
    { path: '**', redirectTo: '', pathMatch: 'full' },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class PlatformsRoutingModule {}
